<div class="vh-100 d-flex flex-row justify-between align-items-center">

  <c-container>
    <c-row class="justify-content-center">
      <c-col md="8">
        <c-card-group>
          <c-card class="p-4" style="border: none">
            <c-card-body>
              <img src="assets/logo-inge.png" height="69" width="68" style="margin-bottom: 80px;" />
              <form cForm [formGroup]="loginForm" (ngSubmit)="login()" class="form-mat-field">
                <h1
                  style="font-family: 'Roboto', sans-serif; font-weight: bold; font-size: 3rem; color: #2a2a2a; margin: 0 0 30px 0; padding: 0;">
                Inicia Sesión</h1>
                <p
                  style="font-family: 'Roboto', sans-serif; font-size: 1.25rem; color: #636363; margin: 0 0 50px 0; padding: 0; margin-top: 16px!important;">
                Con tus credenciales de InGe!</p>

                <mat-label>Correo electrónico</mat-label>
                <mat-form-field appearance="outline">

                  <!-- <svg cIcon name="cilUser"></svg>                                     -->
                  <input matInput autoComplete="username" cFormControl placeholder="Email" formControlName="email"/>
                </mat-form-field>

                <mat-label class="pass">Contraseña</mat-label>
                <mat-form-field appearance="outline">
                  <input autoComplete="current-password" cFormControl placeholder="***********" type="password"
                    formControlName="password" matInput [type]="hide ? 'password' : 'text'" />
                  <button mat-icon-button style="border: 0px; background: transparent" matSuffix (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <mat-icon>{{
                      hide ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                </mat-form-field>

                <c-row>
                  <c-col xs="12">
                    @if (hideButton) {
                      <button cButton class="px-0 mt-0" style="font-size: 13px" color="link">
                        Olvidé mi contraseña
                      </button>
                    }
                  </c-col>
                  <c-col xs="12">
                    <section>
                      @if (hideButton) {
                        <button type="submit" cButton class="px-4 w-100" style="border-radius: 2px; background-color: #005EEC; border: none; padding: 12px;">
                          Ingresar
                        </button>
                      }
                    </section>
                  </c-col>
                  @if (!hideButton) {
                    <c-col xs="12" class="d-flex justify-content-center spin">
                      <!-- <mat-spinner></mat-spinner> -->
  <div style="
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: #6b7280;
    font-family: Arial, sans-serif;
  ">
    <div style="
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 4px solid #e5e7eb;
      border-top: 4px solid #6366f1;
    "></div>
                        <span style="font-size: 14px;">
                          Cargando...
                        </span>
                      </div>
                    </c-col>
                  }
                  <c-col xs="12" class="d-flex justify-content-center">
                    <span style="border-top: 1px solid #BEBEBE; padding:0 10px; width: 100%; margin: 45px 0;"></span>
                  </c-col>
                  <c-col xs="12" class="d-flex flex-column">
                    <h3 style="font-size: 26px; font-weight: bold; color: black;">Regístrate</h3>
                    <p style="font-size: 18px;">Si eres nuevo, debes acudir al <span style="font-weight: bold;">equipo de TI</span> para que creen tu cuenta y contraseña.</p>

                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>

        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
  <img src="assets/inge-crm.webp" style="height: 100%; width: 100%; object-fit: cover;" />
</div>